import { ExpandableContentShowMore as SourceExpandableContentShowMore } from 'SourceComponent/ExpandableContentShowMore/ExpandableContentShowMore.component';

/** @namespace Component/ExpandableContentShowMore/Component */
export class ExpandableContentShowMore extends SourceExpandableContentShowMore {
    static defaultProps = {
        showElemCount: 10
    };

    componentDidMount() {
        const { isOpen } = this.state;
        const { isCategoryFilter } = this.props;

        if (isOpen) {
            if (this.expandableRef.current) {
                this.expandableContentHeight = this.expandableRef.current.getBoundingClientRect().height;
            }

            if(!this.expandableContentHeight)
                this.setState({ isOpen: true });
            else
                this.setState({ isOpen: false });

            if(isCategoryFilter)
                this.setState({ isOpen: false });
        }
    }

    componentDidUpdate(prevProps) {
        const { children: prevChildren } = prevProps;
        const { children: nextChildren, isCategoryFilter, searchString } = this.props;

        if (prevChildren !== nextChildren) {
            if (this.expandableRef.current && !isCategoryFilter) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ isOpen: true }, () => {
                    this.expandableRef.current.style.height = 'auto';
                });
            }

            if (this.expandableRef.current && !searchString) {
                this.setState({ isOpen: false }, () => {
                    this.expandableRef.current.style.height = this.expandableRef.current.getBoundingClientRect().height;
                });
            }

            if (this.expandableRef.current && searchString) {
                this.setState({ isOpen: true }, () => {
                    this.expandableRef.current.style.height = 'auto';
                });
            }
        }

        const { isExpanding } = this.state;

        if (isExpanding) {
            const ONE_SECOND_IN_MS = 1000;
            const transitionDurationCSStoMS = window
                .getComputedStyle(this.expandableRef.current)
                .getPropertyValue('transition-duration')
                .slice(0, -1) * ONE_SECOND_IN_MS;

            setTimeout(() => this.setState({ isExpanding: false }),
                transitionDurationCSStoMS);
        }

        const { children: { length } } = this.props;
        const { children: { length: prevLength } } = prevProps;

        if (length !== prevLength) {
            this.getExpandableContentHeight();
        }
    }

    renderExpandableChildren() {
        const { isOpen, isExpanding } = this.state;
        const { children: { length }, children, showElemCount } = this.props;

        const child = (isOpen || isExpanding) ? children.slice(showElemCount) : null;
        const filteredChild = child && child.filter(function (el) {
            return el != null;
        });

        const style = {
            height: isOpen ? this.expandableContentHeight === 0 ? Math.round(filteredChild.length * 27) : this.expandableContentHeight : 0,
            maxHeight: '100%'
        };

        return (
            <div
                ref={ this.expandableRef }
                block="ExpandableContentShowMore"
                elem="ExpandableChildren"
                style={ style }
            >
                { child }
            </div>
        );
    }
}
export default ExpandableContentShowMore;
